import { env } from './env';

export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },

  auth: {
    login: {
      path: '/login',
      getHref: (redirectTo?: string) =>
        `/login?lang=ja${redirectTo ? `&redirectTo=${redirectTo}` : ''}`,
    },
    logout: {
      path: '/logout',
      getHref: () => '/logout',
    },
    callback: {
      path: env.OIDC_CALLBACK_PATH,
      getHref: () => env.OIDC_CALLBACK_PATH,
    },
  },

  onboarding: {
    path: 'onboarding',
    getHref: () => '/o/onboarding',
  },

  error: {
    path: '/error',
    getHref: () => '/error',
  },

  org: {
    root: {
      path: '/o',
      getHref: () => '/o',
    },
    userProfile: {
      path: 'profile',
      getHref: () => '/o/profile',
    },
    selectedOrg: {
      path: ':orgId',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    dashboard: {
      path: '',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    projects: {
      path: 'projects',
      getHref: (orgId: string) => `/o/${orgId}/projects`,
    },
    project: {
      path: 'projects/:projectId',
      getHref: (orgId: string, projectId: string) => `/o/${orgId}/projects/${projectId}`,
    },
    projectNewCalculation: {
      path: 'projects/:projectId/calculations/new',
      getHref: (orgId: string, projectId: string) =>
        `/o/${orgId}/projects/${projectId}/calculations/new`,
    },
    projectCalculationResult: {
      path: 'projects/:projectId/calculations/:calculationId',
      getHref: (orgId: string, projectId: string, calculationId: string) =>
        `/o/${orgId}/projects/${projectId}/calculations/${calculationId}`,
    },
    projectCalculationContinue: {
      path: 'projects/:projectId/calculations/:calculationId/continue',
      getHref: (orgId: string, projectId: string, calculationId: string) =>
        `/o/${orgId}/projects/${projectId}/calculations/${calculationId}/continue`,
    },
    users: {
      path: 'users',
      getHref: (orgId: string) => `/o/${orgId}/users`,
    },
    user: {
      path: 'users/:userId',
      getHref: (orgId: string, userId: string) => `/o/${orgId}/users/${userId}`,
    },
    roles: {
      path: 'roles',
      getHref: (orgId: string) => `/o/${orgId}/roles`,
    },
    role: {
      path: 'roles/:roleId',
      getHref: (orgId: string, roleId: string) => `/o/${orgId}/roles/${roleId}`,
    },
    orgProfile: {
      path: 'org-profile',
      getHref: (orgId: string) => `/o/${orgId}/org-profile`,
    },
    masterData: {
      path: 'master-data',
      getHref: (orgId: string) => `/o/${orgId}/master-data`,
    },
    projectNew: {
      path: 'projects/new',
      getHref: (orgId: string) => `/o/${orgId}/projects/new`,
    },
    devAssignRole: {
      path: 'dev/assign-role',
      getHref: (orgId: string) => `/o/${orgId}/dev/assign-role`,
    },
  },

  app: {
    root: {
      path: '',
      getHref: () => '/admin',
    },
    dashboard: {
      path: '',
      getHref: () => '/admin',
    },
    users: {
      path: 'users',
      getHref: () => '/admin/users',
    },
    orgs: {
      path: 'orgs',
      getHref: () => '/admin/orgs',
    },
    roles: {
      path: 'roles',
      getHref: () => '/admin/roles',
    },
    profile: {
      path: 'profile',
      getHref: () => '/admin/profile',
    },
    user: {
      path: 'user/:userId',
      getHref: (userId: string) => `/admin/user/${userId}`,
    },
    apps: {
      path: 'apps',
      getHref: () => '/admin/apps',
    },
    app: {
      path: 'apps/:appId',
      getHref: (appId: string) => `/admin/apps/${appId}`,
    },
  },
} as const;
